<template>
    <div class="survey-recognitions-container">
        <div class="survey-recognitions-container__field">
            <div class="form-container" v-for="(child, index) in model.recognitions"
                 v-bind:key="index">
                <div class="form-container__field">
                    <md-field>
                        <label>Rozpoznanie</label>
                        <md-input v-model="child.recognition" v-on:change="onModelChange" :disabled="readonlyMode"
                        ></md-input>
                    </md-field>
                </div>
                <div class="print">
                  <span>Uwagi do rozpoznania</span>
                  <div>{{ child.comments }}</div>
                </div>
                <div class="form-container__textarea not-print">
                  <md-field>
                    <label>Uwagi do rozpoznania</label>
                    <md-textarea 
                      v-model="child.comments" 
                      v-on:change="onModelChange" 
                      v-on:keyup="onCommentsKeyup" 
                      :disabled="readonlyMode"
                    ></md-textarea>
                  </md-field>
                </div>
                <btn v-if="!readonlyMode && model.recognitions.length > 1" class="remove-recognition-btn btn-text"
                     text="Usuń" @click="removeChild(index)"></btn>
            </div>
            <btn class="add-recognition-btn btn-text" v-if="!readonlyMode"
                 text="+ Dodaj rozpoznanie" @click="addNewChild"></btn>
        </div>
    </div>
</template>

<script>
import store from '../../store';
import {resizeTextarea, resizeAllTextarea} from '../../app-func';

export default {
  name: 'SurveyRecognitions',
  props: ['field'],
  data() {
    return {
      readonlyMode: store.state.visit.readonlyMode,
      model: {
        recognitions: [{
          recognition: null,
          comments: null,
        }],
      },
    };
  },
  methods: {
    addNewChild() {
      this.model.recognitions.push({
        recognition: null,
        comments: null,
      });
    },
    removeChild(index) {
      this.model.recognitions.splice(index, 1);
      this.onModelChange();
    },
    onCommentsKeyup (event) {
      resizeTextarea(event);
    },
    onModelChange() {
      this.$emit('modelChange', {
        newVal: JSON.stringify(this.model),
        oldVal: JSON.stringify(this.field.value),
        fieldId: this.field.id,
      });
      this.field.value = JSON.stringify(this.model);
      this.$emit('nodeChange', this.field);
    },
  },
  created() {
    if (this.model.recognitions.length === 0) {
      this.addNewChild();
    }

    if (this.field.value) {
      this.model = JSON.parse(this.field.value);
    }
  },
  mounted() {
    resizeAllTextarea();
  },
};
</script>

<style src="./SurveyRecognitions.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/SurveyRecognitions/SurveyRecognitions.vue